import { Navigate } from "react-router-dom";

const AuthenticatedUsers = ({ isLoggedIn, children }) => {
  if (isLoggedIn) {
    return <Navigate to="/home" replace />;
  }
  return children;
};

export default AuthenticatedUsers;
